// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__R4eSw"};